import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BreakpointMinService } from 'src/app/@utils/breakpoint-min.service';
import { TranslateSafePipe } from '../../../@shared/translate-safe/translate-safe.pipe';
import { SliderComponent } from '../../slider/slider/slider.component';
import { SvgIconComponent } from '../../../@shared/svg-icon/svg-icon.component';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-gift-options-slider',
    templateUrl: './gift-options-slider.component.html',
    styleUrls: ['./gift-options-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgClass, SvgIconComponent, SliderComponent, AsyncPipe, TranslateSafePipe]
})
export class GiftOptionsSliderComponent {
    @Input() public readonly centerAlign: boolean = true;
    @Input() public headline: string;
    @Input() public selectedOptionIndex: number = 0;

    constructor(public breakpointServiceMin: BreakpointMinService) {}
}
